import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { RouterLink } from '@angular/router';
import { injectMutation } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';
import { AuthenticationService } from 'src/app/shared';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    MatFormField,
    MatInput,
    MatLabel,
    MatButton,
    RouterLink,
    ReactiveFormsModule,
    MatLabel
  ],
  templateUrl: './forgot-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AuthenticationService]
})
export class ForgotPasswordComponent {
  form = new FormGroup({
    email: new FormControl<string>('', [Validators.required, Validators.email])
  });

  authenticationService = inject(AuthenticationService);

  submitted = signal(false);

  mutation = injectMutation((_) => ({
    mutationFn: (email: string) =>
      lastValueFrom(this.authenticationService.requestResetPassword(email)),
    onSuccess: () => this.submitted.update(() => true)
  }));

  onSubmit() {
    if (this.form.valid) {
      this.mutation.mutate(this.form.value.email);
    }
  }
}
